import _ from "underscore"
import PDFDefinitionCreator from "./PDFDefinitionCreator"
import {DateFormat} from "../../date_format"
import PDFParametersFormattingStrategy from "./PDFParametersFormattingStrategy"
import TableDataConverter from "../../reports/leavesReport/TableDataConverter"
import {createPdf} from '../utils'

export default class LeavesReportPDFGenerator {
    init({store, generalStore, productSettingsValidator, reportRightsValidator, manageableUserIds, projectsWithMaIds, reportAuthorizationInfo, reportParamsStringBuilderConstructor})
    {
        this.docDefinitionCreator = new PDFDefinitionCreator();
        this.onGenerateBreaker = {needBreak: false};
        this.store = store;
        this.generalStore = generalStore;
        this.productSettingsValidator = productSettingsValidator;
        this.reportRightsValidator = reportRightsValidator;
        this.manageableUserIds = manageableUserIds
        this.projectsWithMaIds = projectsWithMaIds
        this.reportAuthorizationInfo = reportAuthorizationInfo
        this.reportParamsStringBuilderConstructor = reportParamsStringBuilderConstructor

        return this;
    }

    interruptGeneration()
    {
        this.onGenerateBreaker.needBreak = true;
    }

    _getCreatePDFDefinitionStrategy()
    {
        return null;
    }

    _getParametersFormattingStrategy(config) {
        const dateFormatForFileName = new DateFormat('yyyy-MM-dd')
        return (new PDFParametersFormattingStrategy()).init({
            users: this.generalStore.getVisibleUsers(),
            userGroups: this.generalStore.getUserGroups(),
            timeZoneGroups: this.generalStore.getTimeZoneGroups(),
            leaveTypesMap: LeaveTypeStore.getLeaveTypes(),
            dateFormat: config.dateFormat,
            dateFormatForFile: dateFormatForFileName,
            productSettingsValidator: this.productSettingsValidator,
            reportRightsValidator: this.reportRightsValidator,
            manageableUserIds: this.manageableUserIds,
            projectsWithMaIds: this.projectsWithMaIds,
            reportAuthorizationInfo: this.reportAuthorizationInfo,
            reportParamsStringBuilderConstructor: this.reportParamsStringBuilderConstructor,
        })
    }

    calculateTotalNumberOfPages(params)
    {
        return 0;
    }

    generatePDF(additionalDataProvider)
    {
        var newBreaker = {
            needBreak: false
        };
        this.onGenerateBreaker = newBreaker;

        var pdfPrintParameters = this.store.getPrintParametersForSave();
        var chartSectionConfig = this.store.getChartSectionConfig();
        var reportParams = this.store.getReportParams();

        var showAssignedOnly = this.store.isShowAssignedOnlyEnabled() && this.store.isShowAssignedOnly();
        var viewerInfo = this.store.getViewerInfo();
        var assignedInfo = {isShowOnlyAssigned: showAssignedOnly, viewerInfo : viewerInfo};

        reportParams.showAssignedOnly = showAssignedOnly;

        var reportData = this.store.getReportData();
        var defaultWorkDayDuration = this.store.getDefaultWorkDayDuration();

        var totals = {
            totalValue: reportData.totalLeaveSpent,
            totalsMap: _.object(_.map(reportData.leaveSpent, function(item) {
                return [item.leaveTypeId, item.leaveSpent];
            })),
            ptoBalance: reportData.ptoBalance,
            sickBalance: reportData.sickBalance
        };
        var rows = new TableDataConverter(reportData, reportParams).convert();
        var leaveTypeIds = _.pluck(reportData["leaveSpent"], "leaveTypeId");

        var pdfConfig = {
            pdfPrintParameters: pdfPrintParameters,
            chartSectionConfig: chartSectionConfig,
            pdfData: {
                tableData: rows,
                leaveTypeIds: leaveTypeIds,
                chartImage: null,
                totals: totals,
                defaultWorkDayDuration: defaultWorkDayDuration
            },
            reportParams: reportParams,
            assignedInfo: assignedInfo,
            dateFormat: new DateFormat(window.SystemSettings.dateFormat)
        };

        var s = this;
        return new Promise(
            function(onComplete)
            {
                if (s.isNeedRetrieveAdditionalData(pdfConfig))
                {
                    additionalDataProvider(
                        s.getAdditionalDataConfig(pdfConfig),
                        function(additionalData)
                        {
                            s.updateConfigWithAdditionalData(pdfConfig, additionalData);
                            onComplete(pdfConfig);
                        })
                }
                else
                {
                    onComplete(pdfConfig);
                }
            }
        ).then(
            function (pdfConfig) {
                return new Promise(function (onComplete, onError){
                    defer(_.bind(onComplete, this, pdfConfig));
                });
            }
        ).then(
            function(pdfConfig)
            {
                if (newBreaker["needBreak"])
                {
                    return Promise.reject(new Error("abort"));
                }
                return s._generatePDF(pdfConfig, newBreaker);
            }
        );
    }

    isNeedRetrieveAdditionalData(pdfConfig)
    {
        return this.store.getChartSectionConfig()["showChart"];
    }

    getAdditionalDataConfig(pdfConfig)
    {
        return {
            chartImageSizes: this.docDefinitionCreator.getChartImageSizes(pdfConfig.pdfPrintParameters)
        }
    }

    updateConfigWithAdditionalData(pdfConfig, additionalData)
    {
        pdfConfig.pdfData.chartImage = additionalData["chartImage"];
    }

    _generatePDF(config, breaker)
    {
        var paramFormattingStrategy = this._getParametersFormattingStrategy(config);

        return this.docDefinitionCreator
                   .createDocDefinition(config, paramFormattingStrategy, this.store)
                   .then(
                       function(ddObject)
                       {
                           var doc = createPdf(ddObject["docDefinition"]);
                           var currentFileName = paramFormattingStrategy.formatChartPDFFileName(config.reportParams);

                           return new Promise(function(onComplete, onError)
                           {
                               try
                               {
                                   doc._createDoc(
                                       {
                                           tableLayouts: ddObject["tableLayouts"]
                                       },
                                       function(result, pages)
                                       {
                                           if (breaker.needBreak)
                                           {
                                               return onError(new Error("abort"));
                                           }

                                           onComplete({
                                               encodedPDF: result,
                                               fileName: currentFileName,
                                               pageCount: pages.length
                                           })
                                       }
                                   );

                               }
                               catch (e)
                               {
                                   onError(e);
                               }
                           });
                       }
                   );
    }
}


// WEBPACK FOOTER //
// ./web/js/pdf/leavesReport/PDFGenerator.js